const state = {
  printLocations: []
}

const actions = {
  setPrintLocations ({ commit }, payload) {
    commit('SET_PRINT_LOCATIONS', payload)
  },
  addPrintLocation ({ commit }, payload) {
    commit('ADD_PRINT_LOCATION', payload)
  },
  deletePrintLocation ({ commit }, index) {
    commit('DELETE_PRINT_LOCATION', index)
  },
  clearPrintLocation ({ commit }) {
    commit('CLEAR_PRINT_LOCATION')
  }
}

const mutations = {
  SET_PRINT_LOCATIONS (state, payload) {
    state.printLocations = payload
  },
  ADD_PRINT_LOCATION (state, payload) {
    state.printLocations.push(payload)
  },
  DELETE_PRINT_LOCATION (state, index) {
    state.printLocations.splice(index, 1)
  },
  CLEAR_PRINT_LOCATION (state) {
    state.printLocations = []
  }
}

const getters = {
  printLocations: (state) => state.printLocations
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
